import React, { Component } from "react";

export default class Timeline extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-experience" data-section="timeline">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div
                className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
                data-animate-effect="fadeInLeft"
              >
                <span className="heading-meta">highlights</span>
                <h2 className="colorlib-heading animate-box">Timeline</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="timeline-centered">
                <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInLeft"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          FullStack Developer at Bitcoding Solutions Surat,Gujrat India.
                          <span> Apr 2022 To Present</span>
                        </h2>
                        <p>
                        <h5>● Developing and maintaining server-side applications using languages such as Node.js or Python Django.</h5>
                          <h5>● Creating and maintaining client-side applications using JavaScript frameworks such as React, Angular, Django.</h5>
                          <h5>● Designing and developing databases, and writing efficient SQL queries to manage data.</h5>
                          <h5>● Writing unit tests and end-to-end tests to ensure the quality of the code.</h5>
                          <h5>● Collaborating with other team members, including designers and product managers, to ensure the product meets business requirements and user needs.</h5>
                          <h5>● Staying up-to-date with emerging technologies and industry trends to continuously improve the product and the development process.</h5>
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInLeft"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          Software Engineer at Propelius Technology Surat,Gujrat India.
                          <span> Oct-2019 To Sep-2021</span>
                        </h2>
                        <p>
                          <h5>● Analyze user requirements.</h5>
                          <h5>● Involved in requirement gathering, analysis, design and estimation of the assigned projects.</h5>
                          <h5>● Write and test code, refining and rewriting it as necessary and communicate with any
                            programmers involved in the project.</h5>
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInLeft"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          Python Developer at GlobaliaSoft Llp Surat,Gujrat India.
                          <span> Oct-2019 To Sep-2021</span>
                        </h2>
                        <p>
                          <h5>● Experience in developing various web-based, client-server and distributed applications using
                            Python, Django, NodeJs, Angular 6+, ReactJs.</h5>
                          <h5>● Involved in requirement gathering, analysis, design and estimation of the assigned projects.</h5>
                          <h5>● Trained and supervised new employees and provided technical support to clients and coworkers.</h5>
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInLeft"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          Internship at Tops Technology Surat,Gujrat India.
                          <span> June-2019 To Sep-2019</span>
                        </h2>
                        <p>
                          <h5>● Developing and Learning Python and Django based web applications.</h5>
                          <h5>● Building Documentation of developed projects.</h5>
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry animate-box"
                    data-animate-effect="fadeInTop"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-4">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          Graduation at North Maharastra University. <span>2016 To 2019</span>
                        </h2>
                        <p>
                          <h5>● I am Completed my graduation studies with major in
                            Bvoc(Bachelor of Vocationl in Software Developement).
                            I have taken courses like DSA, OOPs, Computer
                            Networks, over the years and have better understanding
                            of these subjects.</h5>
                        </p>
                      </div>
                    </div>
                  </article>
                  <article
                    className="timeline-entry begin animate-box"
                    data-animate-effect="fadeInBottom"
                  >
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-none"></div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
